if ($('#pg_customers').length > 0) {

	// SHOW CONTACTS
		$(document).off('click', '.btnContactsCustomerModal').on('click', '.btnContactsCustomerModal', function(e){
			e.stopPropagation();
			var button = $(this);
			$('#contactsCustomerModal .modal-body').html('');
			ejecutar_ajax('/contactos/clientes/' + button.data('customer-id'), 'html', { _token: button.data('token') }, button, function(result) {
				$('#contactsCustomerModal .modal-body').html(result);
				$('#contactsCustomerModal').modal('show');
			});
			return false;
		});

		$('#contactsCustomerModal').on('shown.bs.modal', function () {
			$('#customer_contact_name').focus();
		});

	// ADD CONTACTS
		$(document).off('click', '#btnAddCustomerContact').on('click', '#btnAddCustomerContact', function(e) {
			e.stopPropagation();
			var btn = $(this);
			ejecutar_ajax('/contactos/clientes/' + btn.data('customer-id') + '/almacenar', 'html', $('#frm_customers_contacts').serialize(), btn, function(result) {
				$("#tbl_customers_contacts tbody").prepend(result);
				$('#tbl_customers_contacts tbody tr').each(function (index) {
					$(this).children('td').eq(0).text(index + 1);
				});
				resetInput($('#frm_customers_contacts'));
				$('#customer_contact_name').focus();
			});
			return false;
		});

	// REMOVE CONTACTS
		$(document).off('click', '.btnDeleteCustomerContact').on('click', '.btnDeleteCustomerContact', function(e) {
			e.stopPropagation();
			var btn = $(this);
			if (confirm('¿Seguro(a) qué desea remover el contacto ' + btn.data('contact-name') + '?')) {
				var datos = {
					_token: btn.data('token'),
					_method: 'DELETE'
				}
				ejecutar_ajax('/contactos/clientes/' + btn.data('contact-id'), 'json', datos, btn, function(result) {
					if (result == 1) {
						$("#tbl_customers_contacts tbody").find("tr[data-contact-id='" + btn.data('contact-id') + "']").remove();
					}
				});
			}
			return false;
		});

}
